import { Action } from 'redux'
import { UserTransaction } from '../../communication/PlayerApiProtocol.generated'
import {
	assign,
	AsyncState,
	AsyncStatus,
	createAsyncState,
	handleAsyncError,
	handleAsyncRequest,
	ReduxAction,
} from '../ReduxUtils'
import { RECEIVE_TRANSACTIONS, REQUEST_TRANSACTIONS, TRANSACTIONS_ERROR } from './TransactionHistoryActions'
import { Feature, userFeatureService } from '../../services/UserFeatureService'

export interface TransactionHistoryState extends AsyncState {
    transactions? : UserTransaction[];
    loading? : boolean;
}

const initialTransactions : TransactionHistoryState =  createAsyncState({
	transactions : [],
	loading : true
})

export function transactionHistoryReducer(state : TransactionHistoryState = initialTransactions, anAction: Action ) : TransactionHistoryState {
	var action : ReduxAction<any> = anAction as ReduxAction<any>
	switch (action.type) {
	case RECEIVE_TRANSACTIONS:
		return handleTransactions(state,action)
	case REQUEST_TRANSACTIONS:
		return handleAsyncRequest(state,action)
	case TRANSACTIONS_ERROR:
		return handleAsyncError(state)
	default:
		return state
	}
}

const handleTransactions = (state : TransactionHistoryState, action : ReduxAction<UserTransaction[]>) : TransactionHistoryState =>{
	const transactions = !userFeatureService.doesUserHaveFeature(Feature.SLOTS_LOBBY)
		? action.payload.filter(isNotSlotsTransaction)
		: action.payload

	return assign<TransactionHistoryState>({}, state, {
		transactions,
		loading : false,
		status : AsyncStatus.COMPLETED,
		lastReceived : action.createdTime
	})
}

const isNotSlotsTransaction = (transaction: UserTransaction): boolean => {
	return !transaction.type.startsWith('slot')
}
